import { IconNote, IconTeams } from '../../../common/icons';
import { NAME_MAX, STATUS_OPTIONS } from '../utils/form';

import '../../clients/styles/form.css';

// The team form body, shared by create and edit. Same form language as the
// rest of the panel (design/referencias/form.png) — the stylesheet is the one
// the clients feature owns; the day a third form needs it, that file moves to
// common/.

export default function TeamFields({ values, errors = {}, onChange, disabled }) {
    const set = (field) => (e) => onChange(field, e.target.value);

    return (
        <div className="client-form__grid">
            <label className="client-form__field">
                <span className="client-form__label">
                    Nombre <span className="client-form__required">*</span>
                </span>
                <span className="client-form__control">
                    <input
                        className={`client-form__input ${errors.name ? 'client-form__input--invalid' : ''}`}
                        type="text"
                        value={values.name}
                        onChange={set('name')}
                        maxLength={NAME_MAX}
                        placeholder="Nombre del equipo"
                        disabled={disabled}
                        required
                    />
                    <span className="client-form__icon" aria-hidden="true"><IconTeams /></span>
                </span>
                {errors.name && <span className="client-form__error">{errors.name}</span>}
            </label>

            <label className="client-form__field">
                <span className="client-form__label">Estado</span>
                <span className="client-form__control">
                    <select
                        className="client-form__input client-form__input--select"
                        value={values.status}
                        onChange={set('status')}
                        disabled={disabled}
                    >
                        {STATUS_OPTIONS.map(option => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                        ))}
                    </select>
                </span>
                {errors.status && <span className="client-form__error">{errors.status}</span>}
            </label>

            <label className="client-form__field client-form__field--wide">
                <span className="client-form__label">Descripción</span>
                <span className="client-form__control">
                    <textarea
                        className={`client-form__input client-form__input--area ${errors.description ? 'client-form__input--invalid' : ''}`}
                        value={values.description}
                        onChange={set('description')}
                        rows={4}
                        placeholder="Para qué existe este equipo y de qué se ocupa"
                        disabled={disabled}
                    />
                    <span className="client-form__icon client-form__icon--top" aria-hidden="true">
                        <IconNote />
                    </span>
                </span>
                {errors.description && <span className="client-form__error">{errors.description}</span>}
            </label>
        </div>
    );
}
